import { render, staticRenderFns } from "./FiltersList.vue?vue&type=template&id=9abfa770&scoped=true"
import script from "./FiltersList.vue?vue&type=script&lang=ts"
export * from "./FiltersList.vue?vue&type=script&lang=ts"
import style0 from "./FiltersList.vue?vue&type=style&index=0&id=9abfa770&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abfa770",
  null
  
)

export default component.exports